






import { Component, Vue } from 'vue-property-decorator'

@Component({})
export default class Alert extends Vue {
    show = false
    message: string = null
    type: string

    handleAlert(type: string, message: string, duration: number = 3000) {
        this.show = true
        this.message = message
        this.type = type

        setTimeout(() => {
            this.show = false
        }, duration)
    }

    get messageWithBR() {
        if (!this.message) {
            return null
        }
        return this.message.trim().replace(/\n/g, '<br />')
    }
}
